module.exports = __webpack_public_path__ + "static/media/bonariv-section-1.c6a6bbd4.png";